import { Candidate, Status, Note } from "../types";

const STORAGE_KEY = "ats_candidates_data";

export const CandidateService = {
  getAll: (): Candidate[] => {
    const data = localStorage.getItem(STORAGE_KEY);
    const parsed = data ? JSON.parse(data) : [];
    // Migration: Ensure all candidates have a notes array (even old ones)
    return parsed.map((c: any) => ({ ...c, notes: c.notes || [] }));
  },

  add: (
    candidate: Omit<Candidate, "id" | "appliedDate" | "notes">
  ): Candidate => {
    const current = CandidateService.getAll();
    const newCandidate: Candidate = {
      ...candidate,
      id: crypto.randomUUID(),
      appliedDate: new Date().toLocaleDateString(),
      notes: [], // Initialize empty notes
    };
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify([...current, newCandidate])
    );
    return newCandidate;
  },

  updateStatus: (id: string, status: Status): void => {
    const current = CandidateService.getAll();
    const updated = current.map((c) => (c.id === id ? { ...c, status } : c));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  },

  addNote: (candidateId: string, text: string): void => {
    const current = CandidateService.getAll();
    const newNote: Note = {
      id: crypto.randomUUID(),
      text,
      createdAt: new Date().toLocaleString(),
    };

    const updated = current.map((c) =>
      c.id === candidateId
        ? { ...c, notes: [newNote, ...c.notes] } // Add new note to top
        : c
    );
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  },

  delete: (id: string): void => {
    const current = CandidateService.getAll();
    const filtered = current.filter((c) => c.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
  },
};
